@use "../../sass/variables/colors";

.ux-range-input {
  display: block;

  &__input {
    cursor: pointer;
    height: 40px;
    margin: 0;
    margin-top: -20px;
    opacity: 0;
    position: absolute;
    width: 100%;
  }

  &__track {
    background: colors.$color-grey-3;
    display: block;
    height: 2px;
    inset: 0;
    margin-bottom: 17px;
    margin-top: 15px;
    position: relative;
    width: 100%;
    z-index: 0;

    &::before,
    &::after {
      background: colors.$color-grey-3;
      content: "";
      height: 13px;
      margin-top: 1px;
      position: absolute;
      transform: translateY(-50%);
      width: 13px;
    }

    &::before {
      left: 0;
      top: 0;
      z-index: 0;
    }

    &::after {
      pointer-events: none;
      right: 0;
      top: 0;
      z-index: 0;
    }
  }

  &__marker {
    background: colors.$color-green;
    height: 30px;
    pointer-events: none;
    position: absolute;
    top: -14px;
    transition: background-color 0.25s;
    width: 30px;
    z-index: 1;

    @media only screen and (width >= 768px) {
      height: 36px;
      top: -17px;
      width: 36px;
    }
  }

  &__marker-line {
    background: colors.$color-white;
    height: 14px;
    position: absolute;
    top: 8px;
    width: 1px;

    &:nth-child(1) {
      left: 10px;
    }

    &:nth-child(2) {
      left: 15px;
    }

    &:nth-child(3) {
      left: 20px;
    }

    @media only screen and (width >= 768px) {
      height: 16px;
      top: 10px;
    }
  }

  &__marker-line:nth-child(1) {
    @media only screen and (width >= 768px) {
      left: 12px;
    }
  }

  &__marker-line:nth-child(2) {
    @media only screen and (width >= 768px) {
      left: 18px;
    }
  }

  &__marker-line:nth-child(3) {
    @media only screen and (width >= 768px) {
      left: 24px;
    }
  }

  &__info-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  &__info {
    max-width: 40%;

    > * {
      margin-top: 5px;
    }
  }
}
